import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{body-class "user-invites-page"}}

{{#if this.canInviteToForum}}
  <LoadMore
    @id="user-content"
    @selector=".user-invite-list tr"
    @action={{action "loadMore"}}
    class="user-content"
  >
    <section class="user-additional-controls">
      {{#if this.showSearch}}
        <div class="user-invite-search">
          <form><TextField
              @value={{this.searchTerm}}
              @placeholderKey="user.invited.search"
            /></form>
        </div>
      {{/if}}
      <section class="user-invite-buttons">
        <DButton
          @icon="plus"
          @action={{this.createInvite}}
          @label="user.invited.create"
          class="btn-default"
        />
        {{#if this.canBulkInvite}}
          {{#if this.siteSettings.allow_bulk_invite}}
            {{#if this.site.desktopView}}
              <DButton
                @icon="upload"
                @action={{this.createInviteCsv}}
                @label="user.invited.bulk_invite.text"
                class="btn-default"
              />
            {{/if}}
          {{/if}}
        {{/if}}
        {{#if this.showBulkActionButtons}}
          {{#if this.inviteExpired}}
            {{#if this.removedAll}}
              <span class="removed-all">
                {{i18n "user.invited.removed_all"}}
              </span>
            {{else}}
              <DButton
                @icon="times"
                @action={{this.destroyAllExpired}}
                @label="user.invited.remove_all"
              />
            {{/if}}
          {{/if}}

          {{#if this.invitePending}}
            {{#if this.reinvitedAll}}
              <span class="reinvited-all">
                <DButton
                  @icon="check"
                  @disabled={{true}}
                  @label="user.invited.reinvited_all"
                />
              </span>
            {{else if this.hasEmailInvites}}
              <DButton
                @icon="sync"
                @action={{this.reinviteAll}}
                @label="user.invited.reinvite_all"
                class="btn-default"
              />
            {{/if}}
          {{/if}}
        {{/if}}
      </section>
    </section>
    <section>
      {{#if this.model.invites}}
        {{#if this.inviteRedeemed}}
          <table class="table user-invite-list">
            <thead>
              <tr>
                <th>{{i18n "user.invited.user"}}</th>
                <th>{{i18n "user.invited.redeemed_at"}}</th>
                {{#if this.model.can_see_invite_details}}
                  <th>{{i18n "user.last_seen"}}</th>
                  <th>{{i18n "user.invited.topics_entered"}}</th>
                  <th>{{i18n "user.invited.posts_read_count"}}</th>
                  <th>{{i18n "user.invited.time_read"}}</th>
                  <th>{{i18n "user.invited.days_visited"}}</th>
                  <th>{{i18n "user.invited.invited_via"}}</th>
                {{/if}}
              </tr>
            </thead>
            <tbody>
              {{#each this.model.invites as |invite|}}
                <tr>
                  <td>
                    <LinkTo @route="user" @model={{invite.user}}>{{avatar
                        invite.user
                        imageSize="tiny"
                      }}</LinkTo>
                    <LinkTo
                      @route="user"
                      @model={{invite.user}}
                    >{{invite.user.username}}</LinkTo>
                  </td>
                  <td>{{format-date invite.redeemed_at}}</td>
                  {{#if this.model.can_see_invite_details}}
                    <td>{{format-date invite.user.last_seen_at}}</td>
                    <td>{{number invite.user.topics_entered}}</td>
                    <td>{{number invite.user.posts_read_count}}</td>
                    <td>{{format-duration invite.user.time_read}}</td>
                    <td>
                      <span
                        title={{i18n "user.invited.days_visited"}}
                      >{{html-safe invite.user.days_visited}}</span>
                      /
                      <span
                        title={{i18n "user.invited.account_age_days"}}
                      >{{html-safe invite.user.days_since_created}}</span>
                    </td>
                    <td>{{html-safe invite.invite_source}}</td>
                  {{/if}}
                </tr>
              {{/each}}
            </tbody>
          </table>
        {{else}}
          <table class="table user-invite-list">
            <thead>
              <tr>
                <th>{{i18n "user.invited.invited_via"}}</th>
                <th>{{i18n "user.invited.sent"}}</th>
                <th>{{i18n "user.invited.expires_at"}}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {{#each this.model.invites as |invite|}}
                <tr>
                  <td class="invite-type">
                    <div class="label">{{i18n "user.invited.invited_via"}}</div>
                    {{#if invite.email}}
                      {{d-icon "envelope"}}
                      {{invite.email}}
                    {{else}}
                      {{d-icon "link"}}
                      {{i18n
                        "user.invited.invited_via_link"
                        key=invite.shortKey
                        count=invite.redemption_count
                        max=invite.max_redemptions_allowed
                      }}
                    {{/if}}

                    {{#each invite.groups as |g|}}
                      <p class="invite-extra"><a href="/g/{{g.name}}">{{d-icon
                            "users"
                          }}
                          {{g.name}}</a></p>
                    {{/each}}

                    {{#if invite.topic}}
                      <p class="invite-extra"><a
                          href={{invite.topic.url}}
                        >{{d-icon "file"}} {{invite.topic.title}}</a></p>
                    {{/if}}
                  </td>

                  <td class="invite-updated-at">
                    <div class="label">{{i18n "user.invited.sent"}}</div>
                    {{format-date invite.updated_at}}
                  </td>

                  <td class="invite-expires-at">
                    <div class="label">{{i18n "user.invited.expires_at"}}</div>
                    {{#if this.inviteExpired}}
                      {{raw-date invite.expires_at}}
                    {{else if invite.expired}}
                      {{i18n "user.invited.expired"}}
                    {{else}}
                      {{raw-date invite.expires_at}}
                    {{/if}}
                  </td>

                  {{#if invite.can_delete_invite}}
                    <td class="invite-actions">
                      <DButton
                        @icon="pencil-alt"
                        @action={{fn this.editInvite invite}}
                        @title="user.invited.edit"
                        class="btn-default"
                      />
                      <DButton
                        @icon="trash-alt"
                        @action={{fn this.destroyInvite invite}}
                        @title={{if
                          invite.destroyed
                          "user.invited.removed"
                          "user.invited.remove"
                        }}
                        class="cancel"
                      />
                    </td>
                  {{/if}}
                </tr>
              {{/each}}
            </tbody>
          </table>
        {{/if}}

        <ConditionalLoadingSpinner @condition={{this.invitesLoading}} />
      {{else}}
        <div class="user-invite-none">
          {{#if this.canBulkInvite}}
            {{html-safe (i18n "user.invited.bulk_invite.none")}}
          {{else}}
            {{i18n "user.invited.none"}}
          {{/if}}
        </div>
      {{/if}}
    </section>
  </LoadMore>
{{else}}
  <div class="alert alert-error invite-error">
    {{this.model.error}}
  </div>
{{/if}}
*/
{
  "id": "DkwkIZSm",
  "block": "[[[1,[28,[35,0],[\"user-invites-page\"],null]],[1,\"\\n\\n\"],[41,[30,0,[\"canInviteToForum\"]],[[[1,\"  \"],[8,[39,2],[[24,0,\"user-content\"]],[[\"@id\",\"@selector\",\"@action\"],[\"user-content\",\".user-invite-list tr\",[28,[37,3],[[30,0],\"loadMore\"],null]]],[[\"default\"],[[[[1,\"\\n    \"],[10,\"section\"],[14,0,\"user-additional-controls\"],[12],[1,\"\\n\"],[41,[30,0,[\"showSearch\"]],[[[1,\"        \"],[10,0],[14,0,\"user-invite-search\"],[12],[1,\"\\n          \"],[10,\"form\"],[12],[8,[39,4],null,[[\"@value\",\"@placeholderKey\"],[[30,0,[\"searchTerm\"]],\"user.invited.search\"]],null],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,\"section\"],[14,0,\"user-invite-buttons\"],[12],[1,\"\\n        \"],[8,[39,5],[[24,0,\"btn-default\"]],[[\"@icon\",\"@action\",\"@label\"],[\"plus\",[30,0,[\"createInvite\"]],\"user.invited.create\"]],null],[1,\"\\n\"],[41,[30,0,[\"canBulkInvite\"]],[[[41,[30,0,[\"siteSettings\",\"allow_bulk_invite\"]],[[[41,[30,0,[\"site\",\"desktopView\"]],[[[1,\"              \"],[8,[39,5],[[24,0,\"btn-default\"]],[[\"@icon\",\"@action\",\"@label\"],[\"upload\",[30,0,[\"createInviteCsv\"]],\"user.invited.bulk_invite.text\"]],null],[1,\"\\n\"]],[]],null]],[]],null]],[]],null],[41,[30,0,[\"showBulkActionButtons\"]],[[[41,[30,0,[\"inviteExpired\"]],[[[41,[30,0,[\"removedAll\"]],[[[1,\"              \"],[10,1],[14,0,\"removed-all\"],[12],[1,\"\\n                \"],[1,[28,[35,6],[\"user.invited.removed_all\"],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,5],null,[[\"@icon\",\"@action\",\"@label\"],[\"times\",[30,0,[\"destroyAllExpired\"]],\"user.invited.remove_all\"]],null],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n\"],[41,[30,0,[\"invitePending\"]],[[[41,[30,0,[\"reinvitedAll\"]],[[[1,\"              \"],[10,1],[14,0,\"reinvited-all\"],[12],[1,\"\\n                \"],[8,[39,5],null,[[\"@icon\",\"@disabled\",\"@label\"],[\"check\",true,\"user.invited.reinvited_all\"]],null],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"hasEmailInvites\"]],[[[1,\"              \"],[8,[39,5],[[24,0,\"btn-default\"]],[[\"@icon\",\"@action\",\"@label\"],[\"sync\",[30,0,[\"reinviteAll\"]],\"user.invited.reinvite_all\"]],null],[1,\"\\n            \"]],[]],null]],[]]]],[]],null]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"section\"],[12],[1,\"\\n\"],[41,[30,0,[\"model\",\"invites\"]],[[[41,[30,0,[\"inviteRedeemed\"]],[[[1,\"          \"],[10,\"table\"],[14,0,\"table user-invite-list\"],[12],[1,\"\\n            \"],[10,\"thead\"],[12],[1,\"\\n              \"],[10,\"tr\"],[12],[1,\"\\n                \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.invited.user\"],null]],[13],[1,\"\\n                \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.invited.redeemed_at\"],null]],[13],[1,\"\\n\"],[41,[30,0,[\"model\",\"can_see_invite_details\"]],[[[1,\"                  \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.last_seen\"],null]],[13],[1,\"\\n                  \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.invited.topics_entered\"],null]],[13],[1,\"\\n                  \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.invited.posts_read_count\"],null]],[13],[1,\"\\n                  \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.invited.time_read\"],null]],[13],[1,\"\\n                  \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.invited.days_visited\"],null]],[13],[1,\"\\n                  \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.invited.invited_via\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"model\",\"invites\"]]],null]],null],null,[[[1,\"                \"],[10,\"tr\"],[12],[1,\"\\n                  \"],[10,\"td\"],[12],[1,\"\\n                    \"],[8,[39,9],null,[[\"@route\",\"@model\"],[\"user\",[30,1,[\"user\"]]]],[[\"default\"],[[[[1,[28,[35,10],[[30,1,[\"user\"]]],[[\"imageSize\"],[\"tiny\"]]]]],[]]]]],[1,\"\\n                    \"],[8,[39,9],null,[[\"@route\",\"@model\"],[\"user\",[30,1,[\"user\"]]]],[[\"default\"],[[[[1,[30,1,[\"user\",\"username\"]]]],[]]]]],[1,\"\\n                  \"],[13],[1,\"\\n                  \"],[10,\"td\"],[12],[1,[28,[35,11],[[30,1,[\"redeemed_at\"]]],null]],[13],[1,\"\\n\"],[41,[30,0,[\"model\",\"can_see_invite_details\"]],[[[1,\"                    \"],[10,\"td\"],[12],[1,[28,[35,11],[[30,1,[\"user\",\"last_seen_at\"]]],null]],[13],[1,\"\\n                    \"],[10,\"td\"],[12],[1,[28,[35,12],[[30,1,[\"user\",\"topics_entered\"]]],null]],[13],[1,\"\\n                    \"],[10,\"td\"],[12],[1,[28,[35,12],[[30,1,[\"user\",\"posts_read_count\"]]],null]],[13],[1,\"\\n                    \"],[10,\"td\"],[12],[1,[28,[35,13],[[30,1,[\"user\",\"time_read\"]]],null]],[13],[1,\"\\n                    \"],[10,\"td\"],[12],[1,\"\\n                      \"],[10,1],[15,\"title\",[28,[37,6],[\"user.invited.days_visited\"],null]],[12],[1,[28,[35,14],[[30,1,[\"user\",\"days_visited\"]]],null]],[13],[1,\"\\n                      /\\n                      \"],[10,1],[15,\"title\",[28,[37,6],[\"user.invited.account_age_days\"],null]],[12],[1,[28,[35,14],[[30,1,[\"user\",\"days_since_created\"]]],null]],[13],[1,\"\\n                    \"],[13],[1,\"\\n                    \"],[10,\"td\"],[12],[1,[28,[35,14],[[30,1,[\"invite_source\"]]],null]],[13],[1,\"\\n\"]],[]],null],[1,\"                \"],[13],[1,\"\\n\"]],[1]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,\"table\"],[14,0,\"table user-invite-list\"],[12],[1,\"\\n            \"],[10,\"thead\"],[12],[1,\"\\n              \"],[10,\"tr\"],[12],[1,\"\\n                \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.invited.invited_via\"],null]],[13],[1,\"\\n                \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.invited.sent\"],null]],[13],[1,\"\\n                \"],[10,\"th\"],[12],[1,[28,[35,6],[\"user.invited.expires_at\"],null]],[13],[1,\"\\n                \"],[10,\"th\"],[12],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"model\",\"invites\"]]],null]],null],null,[[[1,\"                \"],[10,\"tr\"],[12],[1,\"\\n                  \"],[10,\"td\"],[14,0,\"invite-type\"],[12],[1,\"\\n                    \"],[10,0],[14,0,\"label\"],[12],[1,[28,[35,6],[\"user.invited.invited_via\"],null]],[13],[1,\"\\n\"],[41,[30,2,[\"email\"]],[[[1,\"                      \"],[1,[28,[35,15],[\"envelope\"],null]],[1,\"\\n                      \"],[1,[30,2,[\"email\"]]],[1,\"\\n\"]],[]],[[[1,\"                      \"],[1,[28,[35,15],[\"link\"],null]],[1,\"\\n                      \"],[1,[28,[35,6],[\"user.invited.invited_via_link\"],[[\"key\",\"count\",\"max\"],[[30,2,[\"shortKey\"]],[30,2,[\"redemption_count\"]],[30,2,[\"max_redemptions_allowed\"]]]]]],[1,\"\\n\"]],[]]],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,2,[\"groups\"]]],null]],null],null,[[[1,\"                      \"],[10,2],[14,0,\"invite-extra\"],[12],[10,3],[15,6,[29,[\"/g/\",[30,3,[\"name\"]]]]],[12],[1,[28,[35,15],[\"users\"],null]],[1,\"\\n                          \"],[1,[30,3,[\"name\"]]],[13],[13],[1,\"\\n\"]],[3]],null],[1,\"\\n\"],[41,[30,2,[\"topic\"]],[[[1,\"                      \"],[10,2],[14,0,\"invite-extra\"],[12],[10,3],[15,6,[30,2,[\"topic\",\"url\"]]],[12],[1,[28,[35,15],[\"file\"],null]],[1,\" \"],[1,[30,2,[\"topic\",\"title\"]]],[13],[13],[1,\"\\n\"]],[]],null],[1,\"                  \"],[13],[1,\"\\n\\n                  \"],[10,\"td\"],[14,0,\"invite-updated-at\"],[12],[1,\"\\n                    \"],[10,0],[14,0,\"label\"],[12],[1,[28,[35,6],[\"user.invited.sent\"],null]],[13],[1,\"\\n                    \"],[1,[28,[35,11],[[30,2,[\"updated_at\"]]],null]],[1,\"\\n                  \"],[13],[1,\"\\n\\n                  \"],[10,\"td\"],[14,0,\"invite-expires-at\"],[12],[1,\"\\n                    \"],[10,0],[14,0,\"label\"],[12],[1,[28,[35,6],[\"user.invited.expires_at\"],null]],[13],[1,\"\\n\"],[41,[30,0,[\"inviteExpired\"]],[[[1,\"                      \"],[1,[28,[35,16],[[30,2,[\"expires_at\"]]],null]],[1,\"\\n\"]],[]],[[[41,[30,2,[\"expired\"]],[[[1,\"                      \"],[1,[28,[35,6],[\"user.invited.expired\"],null]],[1,\"\\n\"]],[]],[[[1,\"                      \"],[1,[28,[35,16],[[30,2,[\"expires_at\"]]],null]],[1,\"\\n                    \"]],[]]]],[]]],[1,\"                  \"],[13],[1,\"\\n\\n\"],[41,[30,2,[\"can_delete_invite\"]],[[[1,\"                    \"],[10,\"td\"],[14,0,\"invite-actions\"],[12],[1,\"\\n                      \"],[8,[39,5],[[24,0,\"btn-default\"]],[[\"@icon\",\"@action\",\"@title\"],[\"pencil-alt\",[28,[37,17],[[30,0,[\"editInvite\"]],[30,2]],null],\"user.invited.edit\"]],null],[1,\"\\n                      \"],[8,[39,5],[[24,0,\"cancel\"]],[[\"@icon\",\"@action\",\"@title\"],[\"trash-alt\",[28,[37,17],[[30,0,[\"destroyInvite\"]],[30,2]],null],[52,[30,2,[\"destroyed\"]],\"user.invited.removed\",\"user.invited.remove\"]]],null],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]],null],[1,\"                \"],[13],[1,\"\\n\"]],[2]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n        \"],[8,[39,18],null,[[\"@condition\"],[[30,0,[\"invitesLoading\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"user-invite-none\"],[12],[1,\"\\n\"],[41,[30,0,[\"canBulkInvite\"]],[[[1,\"            \"],[1,[28,[35,14],[[28,[37,6],[\"user.invited.bulk_invite.none\"],null]],null]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,6],[\"user.invited.none\"],null]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,0],[14,0,\"alert alert-error invite-error\"],[12],[1,\"\\n    \"],[1,[30,0,[\"model\",\"error\"]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]],[\"invite\",\"invite\",\"g\"],false,[\"body-class\",\"if\",\"load-more\",\"action\",\"text-field\",\"d-button\",\"i18n\",\"each\",\"-track-array\",\"link-to\",\"avatar\",\"format-date\",\"number\",\"format-duration\",\"html-safe\",\"d-icon\",\"raw-date\",\"fn\",\"conditional-loading-spinner\"]]",
  "moduleName": "discourse/templates/user-invited-show.hbs",
  "isStrictMode": false
});